<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <tt-list *ngIf="setting.show_last_produced_stockbatches === '1'" [ttData]="itemsListStockBatchLasts"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_selection_criteria">
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-2 p-5" ttHeading="h_functions">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>
        </div>

        <tt-list *ngIf="setting.show_last_produced_stockbatches === '1'" class="col-xs-12 col-md-4 p-5" [ttData]="itemsListStockBatchLasts"></tt-list>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="labour" [ttModel]="setting.labour_name" [ttButtons]="labourNameButtons" ttReadonly></tt-input>
        <tt-input *ngIf="setting.show_stockplace === '1'" ttLabel="stockplace" [ttModel]="setting.stockplace_name" ttReadonly></tt-input>
        <tt-input ttLabel="operation" [ttModel]="setting.operation_name" [ttButtons]="operationNameButtons" ttReadonly></tt-input>
        <tt-input *ngIf="setting.show_equipment === '1'" ttLabel="equipment" [ttModel]="setting.equipment_name" [ttButtons]="equipmentNameButtons" ttReadonly></tt-input>

        <form class="form-horizontal sp-0" name="formFinishPohScan" novalidate (ngSubmit)="searchOrScanProductionOrder()" method="get" role="form" [hidden]="setting.show_barcode === '0'">
            <tt-input ttLabel="finishpohscan_search" ttFocus="true" [(ttModel)]="barcode" ttShowClearButton [ttButtons]="barcodeButtons"></tt-input>
        </form>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!setting">
        <tt-button-goto *ngIf="setting.show_paperless === '1'" [ttText]="'m_powcue'" [ttGoto]="'paperlesspo'"></tt-button-goto>
        <tt-button-goto [ttText]="'po_finishes'" [ttGoto]="'pofinishlist'"></tt-button-goto>
        <tt-button-goto [ttText]="'productionstatus'" [ttGoto]="'productionstatus'"></tt-button-goto>
        <tt-button-settings *ngIf="setting.show_setting === '1'"></tt-button-settings>
    </ng-container>
</ng-template>
